import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { withoutSystem, withSystem } from '../data/content';
export function CostOfInaction() {
  return <section aria-labelledby="costo" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-12 text-center" data-id="element-53" data-mp="2uxawcr9tgqoa">
      <Reveal data-id="element-54" data-mp="2zxyndcy1p7ii">
        <h2 id="costo" className="mx-auto max-w-3xl font-display text-2xl md:text-3xl font-bold uppercase text-ink" data-id="element-55" data-mp="2zyi2yn083jtd">
          ¿Cuánto tiempo más vas a seguir queriendo comprender la Biblia… sin
          saber cómo empezar?
        </h2>
      </Reveal>

      <div className="mx-auto mt-6 grid max-w-5xl gap-3 md:grid-cols-2" data-id="element-56" data-mp="3dpd7jn3over5">
        <Reveal className="flex h-full flex-col items-center rounded-2xl border border-line bg-surface-alt p-6" data-id="element-57" data-mp="3iny3vbftleab">
          <h3 className="text-sm font-bold uppercase tracking-[0.18em] text-ink-subtle" data-id="element-58" data-mp="3nnatu51zn1h4">
            Sin Mega Pack
          </h3>
          <ul className="mt-4 w-full space-y-2" data-id="element-59" data-mp="3sluem24ui77w">
            {withoutSystem.map(item => <li key={item} className="flex items-center justify-center gap-2 text-sm text-ink-muted" data-id="element-60" data-mp="3ei151z5rhdsh">
                <XIcon size={14} className="flex-shrink-0 text-danger" strokeWidth={2.5} data-id="element-61" data-mp="34i0m4ebt0zot" />
                <span data-id="element-62" data-mp="30irq12takpq3">{item}</span>
              </li>)}
          </ul>
        </Reveal>

        <Reveal delay={0.05} className="flex h-full flex-col items-center rounded-2xl border border-accent/25 bg-accent-soft p-6" data-id="element-63" data-mp="13o1fgl3okhh">
          <h3 className="text-sm font-bold uppercase tracking-[0.18em] text-accent" data-id="element-64" data-mp="3ng3263mdjmah">
            Con Mega Pack Sabiduría Divina™
          </h3>
          <ul className="mt-4 w-full space-y-2" data-id="element-65" data-mp="3jdggylk7kzm9">
            {withSystem.map(item => <li key={item} className="flex items-center justify-center gap-2 text-sm font-semibold text-ink" data-id="element-66" data-mp="ju5rfdejt1z5">
                <CheckIcon size={14} className="flex-shrink-0 text-success" strokeWidth={3} data-id="element-67" data-mp="29a80xvl1i62x" />
                <span data-id="element-68" data-mp="1zjdcqlo8gweu">{item}</span>
              </li>)}
          </ul>
          <p className="mt-5 font-display text-base font-bold uppercase tracking-wide text-accent" data-id="element-69" data-mp="1zhamq1n2z3a4">
            Tenés una forma concreta de empezar.
          </p>
        </Reveal>
      </div>
    </section>;
}